import React from 'react';
import { Icon, Message, Table } from 'semantic-ui-react';
import { Resultados } from 'src/api';
import { ResumenDeCurso } from 'src/api/protocolo/horarios';
import { Fecha, NombrePersonal } from 'src/componentes';
import { InformacionDeCurso } from '../../componentes/InformacionDeCurso';

type PasesDTO = Resultados<'detalleDelAlumno'>['pasesDeAtraso'];

export type Props = Readonly<{
    pases: PasesDTO;
    todosLosCursos?: Map<string, ResumenDeCurso>;
}>;
class PasesDeAtrasoDeAlumno extends React.PureComponent<Props> {
    public render() {
        const { todosLosCursos } = this.props;
        if (todosLosCursos === undefined) {
            return <Icon loading name='spinner' />;
        }
        if (this.props.pases.length === 0) {
            return (
                <div>
                    <Message info>
                        <Message.Content>
                            El alumno no posee pases de atraso inscritos.
                        </Message.Content>
                    </Message>
                </div>
            );
        }
        return (
            <div>
                <Table collapsing>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell content='Curso' />
                            <Table.HeaderCell content='Minutos' />
                            <Table.HeaderCell content='Fecha' />
                            <Table.HeaderCell content='Ingresado por' />
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {this.props.pases.map(pase => {
                            const informacionDeCurso = todosLosCursos.get(pase.curso);
                            if (informacionDeCurso === undefined) {
                                return null;
                            }

                            return (
                                <Table.Row key={pase.id}>
                                    <Table.Cell selectable>
                                        <InformacionDeCurso {...informacionDeCurso} />
                                    </Table.Cell>

                                    <Table.Cell textAlign='right' content={pase.minutosDeAtraso} />
                                    <Table.Cell content={<Fecha fecha={pase.fecha} />} />

                                    <Table.Cell>
                                        <NombrePersonal
                                            nombre={pase.ingresadoPor.nombre}
                                            patron='%N %P'
                                        />
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

export default PasesDeAtrasoDeAlumno;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/PasesDeAtraso/index.tsx